import React, { useState } from 'react';

const ProximityTable = (props) => {

    const colNames = [
        {variable: 'rank', display: 'Rank',},
        {variable: 'show_name', display: 'Title',},
        {variable: 'content_type', display: 'Content Type',},
        {variable: 'genre', display: 'Genre',},
        {variable: 'genre_taxonomy', display: 'Genre Taxonomy',},
        {variable: 'distance', display: 'Emotional Distance',},
    ];

    const hoverInit = {};
    for (let i=0; i<20; i++) {
        hoverInit[i] = false
    };
    const [hoverClicked, setHoverClicked] = useState(hoverInit);

    const handleShowHover = (event) => {
        const clickedId = event.target.id;
        // console.log(clickedId);
        setHoverClicked({
            [clickedId]: true,
        });
    };


    return (
        <div className='overflow-x-auto relative shadow-md'>
            <p className='text-xl font-bold mb-3'>Content in Proximity</p>

            <table className='w-full text-sm text-center text-gray-500'>
                <thead>
                    <tr>
                        {colNames.map((col,index)=>(
                            <th key={index} scope='col' className='py-3 px-6'>
                                {col.display}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {[...Array(props.data.length).keys()].map((i)=>(
                        <tr key={i}
                            className={hoverClicked[i] ? `bg-gray-100` : `bg-white`}>
                            {colNames.map((col,index)=>(
                            <td key={i.toFixed(0) + index.toFixed(0)}
                                id={i}
                                onMouseOver={handleShowHover}
                                onClick={props.handleShowBtn}
                                className='py-3 px-6'>
                                <button key={i.toFixed(0) + index.toFixed(0)}
                                        id={i}
                                        onMouseOver={handleShowHover}
                                        onClick={props.handleShowBtn}
                                        className= 'px-2'>
                                    {props.data[i][col.variable]}
                                </button>
                            </td>
                    ))}
                        </tr>
                    ))}



                        {/* {colNames.map((col,index)=>(
                            <th key={index} scope='col' className='py-3 px-6'>
                                {props.data[index][col.variable]}
                            </th>
                        ))} */}
                </tbody>
            </table>
        </div>
     );
}

export default ProximityTable;
